(function () {
  'use strict';
  var root = document.querySelector('[data-anom-cro-version]');
  if (!root || root.dataset.croReady) return;
  root.dataset.croReady = 'yes';
  var summary = root.querySelector('.anom-funnel__summary-col');
  var grid = root.querySelector('.anom-funnel__grid');
  var quantity = root.querySelector('[data-step="quantity"]');
  var primary = root.querySelector('.js-funnel-submit');
  var dock = root.querySelector('[data-cro-dock]');
  var pending = false;
  var observedPreview;
  function visible(element) {
    if (!element || element.hidden || !element.getClientRects().length) return false;
    var style = getComputedStyle(element), rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.bottom > 0 && rect.top < innerHeight;
  }
  function update() {
    pending = false;
    var header = document.querySelector('.header');
    var top = Math.max(12, header ? header.getBoundingClientRect().bottom + 16 : 12);
    root.style.setProperty('--cro-top', top + 'px');
    var tall = summary.offsetHeight > innerHeight - top - 16 ? 'yes' : 'no';
    if (summary.dataset.tooTall !== tall) summary.dataset.tooTall = tall;
    // Keep the order card visible; the testimonial below need not fit on screen.
    var card = summary.querySelector('.anom-funnel__summary');
    var cardHeight = card ? card.offsetHeight : summary.offsetHeight;
    var summaryTop = Math.min(top, innerHeight - cardHeight - 16);
    root.style.setProperty('--cro-summary-top', summaryTop + 'px');
    // The card is taller than the final choice; native sticky releases it too early.
    if (innerWidth >= 750 && grid) {
      var gridRect = grid.getBoundingClientRect();
      if (gridRect.top < summaryTop) {
        var summaryWidth = summary.offsetWidth;
        summary.dataset.croPinned = 'yes';
        summary.style.position = 'fixed';
        summary.style.top = summaryTop + 'px';
        summary.style.left = gridRect.right - summaryWidth + 'px';
        summary.style.width = summaryWidth + 'px';
        summary.style.zIndex = '20';
        summary.style.visibility = gridRect.bottom <= summaryTop ? 'hidden' : '';
        summary.style.pointerEvents = gridRect.bottom <= summaryTop ? 'none' : '';
      } else {
        delete summary.dataset.croPinned;
        summary.style.position = '';
        summary.style.top = '';
        summary.style.left = '';
        summary.style.width = '';
        summary.style.zIndex = '';
        summary.style.visibility = '';
        summary.style.pointerEvents = '';
      }
    } else {
      delete summary.dataset.croPinned;
      summary.style.position = '';
      summary.style.top = '';
      summary.style.left = '';
      summary.style.width = '';
      summary.style.zIndex = '';
      summary.style.visibility = '';
      summary.style.pointerEvents = '';
    }
    var overlay = Array.from(document.querySelectorAll('.mobile-menu.open, cart-drawer.active, .drawer.active, [role="dialog"][aria-modal="true"], dialog[open]')).some(visible);
    var cookie = document.getElementById('shopify-pc__banner');
    var keyboard = window.visualViewport && visualViewport.height < innerHeight * .75;
    var locked = /overflow-hidden|klaviyo-prevent-body-scrolling/.test(document.body.className);
    var preview = document.getElementById('PBarNextFrameWrapper');
    var previewOffset = visible(preview) ? Math.ceil(preview.getBoundingClientRect().height) : 0;
    if (preview && preview !== observedPreview && window.ResizeObserver) {
      observedPreview = preview;
      new ResizeObserver(schedule).observe(preview);
    }
    root.style.setProperty('--cro-preview-offset', previewOffset + 'px');
    var quantityReached = quantity && quantity.getBoundingClientRect().top < innerHeight - 110;
    var withinFunnel = root.getBoundingClientRect().bottom > 110;
    var primaryRect = primary.getBoundingClientRect();
    var primaryFullyVisible = primaryRect.top >= top && primaryRect.bottom <= innerHeight - 100 - previewOffset;
    var show = innerWidth < 750 && quantityReached && withinFunnel && previewOffset < 180 && root.dataset.croSelectionValid === 'yes' && !keyboard && !locked && !visible(cookie) && !overlay && !primaryFullyVisible;
    dock.hidden = !show;
    dock.querySelector('button').disabled = primary.disabled;
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
  dock.querySelector('button').addEventListener('click', function () { if (!primary.disabled) primary.click(); });
  root.addEventListener('anom:summary-updated', schedule);
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visitorConsentCollected', schedule);
  document.addEventListener('click', schedule);
  if (window.visualViewport) visualViewport.addEventListener('resize', schedule, {passive:true});
  if (window.ResizeObserver) new ResizeObserver(schedule).observe(summary);
  new MutationObserver(schedule).observe(document.body, {attributes:true, attributeFilter:['class']});
  var menu = document.querySelector('.mobile-menu');
  if (menu) new MutationObserver(schedule).observe(menu, {attributes:true, attributeFilter:['class']});
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      return Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(function (node) {
        return node.nodeType === 1 && (node.matches('#shopify-pc__banner, [role="dialog"], .drawer') || node.querySelector('#shopify-pc__banner, [role="dialog"], .drawer'));
      });
    })) schedule();
  }).observe(document.body, {childList:true, subtree:true});
  update();
})();
